
import XHeader from 'vux/src/components/x-header/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'

import { mapState } from 'vuex'
export default {
name: 'clothes',
props: [],
directives: {
TransferDom
},
components: {
XHeader,
Grid,
GridItem,
XButton,
Popup,
Checker,
CheckerItem,
XTable
},
data () {
return {
id: '',
isDisabled: true,
clothes: [
{
name: '军需服装—上衣',
value: 'coat',
referenceSize: '',
selectSize: JSON.parse(sessionStorage.getItem('clotheSize')) ? JSON.parse(sessionStorage.getItem('clotheSize')).clothes : '请选择',
icon: 'coat',
pictureUrl: require('@/assets/sass/images/clothes/pants.png'),
defaultPicture: 'this.src="' + require('@/assets/sass/images/clothes/coat.png') + '"'
},
{
name: '军需服装—迷彩裤',
value: 'pants',
referenceSize: '',
selectSize: JSON.parse(sessionStorage.getItem('clotheSize')) ? JSON.parse(sessionStorage.getItem('clotheSize')).clothes : '请选择',
icon: 'pants',
pictureUrl: require('@/assets/sass/images/clothes/pants.png'),
defaultPicture: 'this.src="' + require('@/assets/sass/images/clothes/pants.png') + '"'
},
{
name: '军需服装—迷彩帽',
value: 'hat',
referenceSize: '',
selectSize: JSON.parse(sessionStorage.getItem('clotheSize')) ? JSON.parse(sessionStorage.getItem('clotheSize')).hat : '请选择',
icon: 'hat',
pictureUrl: require('@/assets/sass/images/clothes/pants.png'),
defaultPicture: 'this.src="' + require('@/assets/sass/images/clothes/hat.png') + '"'
},
{
name: '军需服装—迷彩鞋',
value: 'shoes',
referenceSize: '',
selectSize: JSON.parse(sessionStorage.getItem('clotheSize')) ? JSON.parse(sessionStorage.getItem('clotheSize')).shoes : '请选择',
icon: 'shoes',
pictureUrl: require('@/assets/sass/images/clothes/pants.png'),
defaultPicture: 'this.src="' + require('@/assets/sass/images/clothes/shoes.png') + '"'
}
],
notice: {
isShow: false,
msg: '(根据身高体重推荐)'
},
sizeShow: false,
popUp: {
title: '',
icon: ''
},
checkeValue: '',
sizes: {
clothes: [],
maleClothes: [],
femaleClothes: [],
hat: [],
shoes: ['34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46']
},
referenceSize: {},
selectSize: {
clothes: '',
hat: '',
shoes: ''
}
}
},
computed: {
...mapState({
token: state => state.token,
userInfo: state => state.userInfo,
flowInfo: state => state.flowInfo,
title: state => state.currentProcedureInfo.name,
currentProcedureInfo: state => state.currentProcedureInfo,
parentRouter: state => state.currentProcedureInfo.parentRouter
})
},
created () {
this.getClothesConfig()
},
mounted () {
if (JSON.parse(sessionStorage.getItem('clotheSize'))) {
this.selectSize = JSON.parse(sessionStorage.getItem('clotheSize'))
}

this.getReferenceSize()

this.getLastData()
},
updated () {},
destroyed () {},
watch: {
},
methods: {
back () {
setTimeout(() => {

this.$router.push({
name: this.parentRouter
})
}, 300)
},

submit () {
this.$vux.loading.show()

let params = {
id: this.id ? this.id : null,
studentId: this.userInfo.id,
flowId: this.flowInfo.flowId,
flowProcedureId: this.currentProcedureInfo.flowProcedureId,
procedureId: this.currentProcedureInfo.procedureId,
sizeClothing: this.clothes[0].selectSize,
sizeHat: this.clothes[2].selectSize,
sizeShoe: this.clothes[3].selectSize
}
this.$api.post('/clothingSize', params, r => {
this.$vux.loading.hide()
setTimeout(() => {
this.$router.push({name: 'itemResult'})
}, 300)
},
err => {
this.$vux.toast.text(err.message, 'middle')
})
},
save (obj) {
if (obj === 'coat' || obj === 'pants') {
this.clothes.forEach(element => {
if (element.value === 'coat' || element.value === 'pants') {
element.selectSize = this.selectSize.clothes
}
})
} else if (obj === 'hat') {
this.clothes.forEach(element => {
if (element.value === 'hat') {
element.selectSize = this.selectSize.hat
}
})
} else if (obj === 'shoes') {
this.clothes.forEach(element => {
if (element.value === 'shoes') {
element.selectSize = this.selectSize.shoes
}
})
}
sessionStorage.setItem('clotheSize', JSON.stringify(this.selectSize))
if (this.selectSize.clothes === '' || this.selectSize.hat === '' || this.selectSize.shoes === '') {
this.isDisabled = true
} else {
this.isDisabled = false
}
this.sizeShow = false
this.notice.isShow = false
},
toClotheSize () {
this.$router.push({name: 'clotheSize'})
},
popupSize (obj) {
if (this.sizeShow) {
this.sizeShow = false
} else {
this.popUp.title = obj.name
this.popUp.icon = obj.icon
this.popUp.value = obj.value
this.popUp.pictureUrl = obj.pictureUrl
this.popUp.defaultPicture = obj.defaultPicture
this.sizeShow = true
}
},
getReferenceSize () {
let data = JSON.parse(sessionStorage.getItem('referenceSize'))

if (data) {
this.clothes.forEach(element => {
if (element.value === 'coat' || element.value === 'pants') {
element.referenceSize = data.coat
} else if (element.value === 'hat') {
element.referenceSize = data.hat
} else if (element.value === 'shoes') {
element.referenceSize = data.shoes
}
})
this.referenceSize = data
this.selectSize = {
clothes: data.coat,
hat: data.hat,
shoes: data.shoes
}
this.clothes[0].selectSize = data.coat
this.clothes[1].selectSize = data.coat
this.clothes[2].selectSize = data.hat
this.clothes[3].selectSize = data.shoes
this.isDisabled = false
this.notice.isShow = true
}
},

getClothesConfig () {
this.$vux.loading.show()
let params = {
flowprocedureId: this.currentProcedureInfo.flowProcedureId
}
this.$api.get('/configClothingSize', params, r => {
this.$vux.loading.hide()
let data = r.data
/* 图片 */
let picUrlArr = []
/* 服装尺码表 */



/* 帽子尺码表 */

/* 配送方式, (保留) */


data.forEach(element => {
if (element.kind === 1) {
/* 图片 */
picUrlArr.push(element.clothesServiceFileBean.url)
picUrlArr.push(element.trousersServiceFileBean.url)
picUrlArr.push(element.hatServiceFileBean.url)
picUrlArr.push(element.shoesServiceFileBean.url)
} else if (element.kind === 2) {
/* 服装尺码表 */
this.sizes.clothes = element.sizeValueList
} else if (element.kind === 3) {
/* 服装尺码表  男 */
this.sizes.maleClothes = element.sizeValueList
} else if (element.kind === 4) {
/* 服装尺码表  女 */
this.sizes.femaleClothes = element.sizeValueList
} else if (element.kind === 5) {
this.sizes.hat = element.hatSizeValueList
}
})
if (this.userInfo.sex === 1) {
this.sizes.clothes = this.sizes.maleClothes
} else if (this.userInfo.sex === 2) {
this.sizes.clothes = this.sizes.femaleClothes
}

this.clothes.forEach((element, i) => {
element.pictureUrl = picUrlArr[i]
})

sessionStorage.setItem('sizeTable', JSON.stringify(this.sizes))
},
err => {
this.$vux.toast.text(err.message, 'middle')
})
},

getLastData () {
this.$vux.loading.show()
let params = {
'studentId': this.userInfo.id,
'flowId': this.flowInfo.flowId,
'procedureId': this.currentProcedureInfo.procedureId
}

this.$api.get('/clothingSize', params,
r => {
this.$vux.loading.hide()
var data = r.data

if (data.length > 0) {
this.id = data[0].id
this.selectSize = {
clothes: data[0].sizeClothing,
hat: data[0].sizeHat,
shoes: data[0].sizeShoe
}
this.notice.isShow = false
this.isDisabled = false
this.clothes[0].selectSize = data[0].sizeClothing
this.clothes[1].selectSize = data[0].sizeClothing
this.clothes[2].selectSize = data[0].sizeHat
this.clothes[3].selectSize = data[0].sizeShoe
}
},
err => {
this.$vux.toast.text(err.message, 'top')
})
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/items/clothes.vue